import { toast } from "@altimateai/lego";

export interface UploadFormData {
  name: string;
  description: string;
  privacy: string;
  icon: string;
  uploadMode: "file" | "markdown";
  selectedFile: File | null;
  markdownContent: string;
  chunkingStrategy: string;
}

export interface SubmitHandlerParams {
  formData: UploadFormData;
  isEditMode: boolean;
  uploadMutation: {
    mutate: (formData: FormData) => void;
  };
  uploadDocumentMutation: {
    mutate: (formData: FormData) => void;
  };
}

export const handleFormSubmit = (params: SubmitHandlerParams) => {
  const { formData, isEditMode, uploadMutation, uploadDocumentMutation } = params;
  const {
    name,
    description,
    privacy,
    icon,
    uploadMode,
    selectedFile,
    markdownContent,
    chunkingStrategy,
  } = formData;

  if (!name.trim()) {
    toast({
      title: "Name required",
      description: "Please enter a name for the knowledge base",
      variant: "destructive",
    });
    return false;
  }

  if (uploadMode === "file" && !selectedFile) {
    toast({
      title: "File required",
      description: "Please select a file to upload",
      variant: "destructive",
    });
    return false;
  }

  if (uploadMode === "markdown" && !markdownContent.trim()) {
    toast({
      title: "Content required",
      description: "Please enter markdown content",
      variant: "destructive",
    });
    return false;
  }

  const formDataToSend = new FormData();

  if (isEditMode) {
    // In edit mode, only send file/markdown and chunking strategy
    formDataToSend.append("chunking_strategy", chunkingStrategy);

    if (uploadMode === "file" && selectedFile) {
      formDataToSend.append("file", selectedFile);
    } else if (uploadMode === "markdown") {
      formDataToSend.append("markdown_content", markdownContent);
    }

    uploadDocumentMutation.mutate(formDataToSend);
  } else {
    // In create mode, send all fields
    formDataToSend.append("name", name.trim());
    formDataToSend.append("description", description.trim());
    formDataToSend.append("privacy", privacy);
    formDataToSend.append("chunking_strategy", chunkingStrategy);
    if (icon) formDataToSend.append("icon", icon);

    if (uploadMode === "file" && selectedFile) {
      formDataToSend.append("file", selectedFile);
    } else if (uploadMode === "markdown") {
      formDataToSend.append("markdown_content", markdownContent);
    }

    uploadMutation.mutate(formDataToSend);
  }

  return true;
};
